import { render, staticRenderFns } from "./ThemesEditorAlphaSortBtn.vue?vue&type=template&id=13513ce5"
import script from "./ThemesEditorAlphaSortBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorAlphaSortBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports